import script from "./DeleteCategoryConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteCategoryConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./DeleteCategoryConfirmDialog.vue?vue&type=style&index=0&id=53ffd6b7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53ffd6b7"]])

export default __exports__